import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "../contexts/LanguageContext";
import { Check } from "lucide-react";

const Quality = () => {
  const { t } = useLang();
  const points = t.quality.points;

  const certs = ["ISO 22000", "HACCP", "GMP+", "Halal", "Kosher", "Non-GMO", "ISO 9001"];

  return (
    <section
      id="quality"
      data-testid="quality-section"
      className="relative bg-[#FDFBF7] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 mb-16">
          <div className="lg:col-span-6 reveal">
            <div className="flex items-center gap-3 mb-6">
              <span className="divider-line" />
              <span className="overline text-[#DE9E36]">{t.quality.overline}</span>
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl text-[#1A201C] font-bold leading-[1.1] tracking-tight">
              {t.quality.title}
            </h2>
          </div>
          <div className="lg:col-span-6 lg:pt-4 reveal">
            <p className="text-base sm:text-lg text-[#4E5750] leading-relaxed">
              {t.quality.subtitle}
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E5E0D8] border border-[#E5E0D8]">
          {points.map((p, i) => (
            <div
              key={i}
              data-testid={`quality-point-${i}`}
              className="reveal bg-[#FDFBF7] p-7 flex items-start gap-4 hover:bg-white transition-colors"
            >
              <span className="flex-shrink-0 w-8 h-8 rounded-full bg-[#DE9E36]/15 text-[#DE9E36] flex items-center justify-center">
                <Check size={16} strokeWidth={2} />
              </span>
              <span className="text-base text-[#1A201C] leading-snug">{p}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Certifications marquee */}
      <div className="mt-20 border-y border-[#E5E0D8] py-8 bg-white/50">
        <Marquee gradient={false} speed={40} pauseOnHover>
          {[...certs, ...certs].map((c, i) => (
            <span
              key={i}
              className="mx-12 text-2xl md:text-3xl text-[#1A201C] font-bold tracking-tight"
            >
              {c} <span className="text-[#DE9E36] mx-2">·</span>
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default Quality;
